import React from "react";

const sarthika_kashmire = () => {
  return (
    <div>
      <h1>Sarthika Kashmire</h1>

      <h4>
        <em>
          Computer Engineering, Batch of 27'
          <br />
          <hr />
        </em>
      </h4>

      <p>
        <strong>
          What was the criteria for shortlisting candidates in the initial
          stages of the recruitment process
        </strong>
        ?<br />
        Wells Fargo set a minimum CGPA criterion of 7.5 to shortlist students
        for the Online Aptitude Test.{" "}
      </p>

      <p>
        <strong>What was the Timeline of the entire Interview Process</strong>?
        <br />
        The test was conducted online from Congizant Lab on 5th September, the
        shortlist was announced on 12th September, and the interviews were held
        on 15th September.
      </p>

      <p>
        <strong>What was the Structure of the Aptitude Round?</strong>
        <br />
        The aptitude round included a mix of logical reasoning and coding
        questions. It had some aptitude questions based on candlestick patterns,
        three coding problems of easy to medium difficulty.
      </p>

      <p>
        The first coding question (1 hour) was based on the minimum number of
        coins required to make a given amount.
      </p>

      <p>
        The other two questions (40 minutes total) focused on string
        manipulation. One of them required finding the common prefix among
        several people’s names given in a single string, which represented the
        name of their city.
      </p>

      <p>
        <strong>
          How many students were shortlisted after the Aptitude Round?
        </strong>
        <br />A total of 25 students were shortlisted from the Online Aptitude
        Test for the interview rounds.
      </p>

      <p>
        <strong>
          After being shortlisted, how long was the wait time before the
          interviews began? During this period, what specific areas did you
          focus on to prepare effectively?
        </strong>
        <br />
        The shortlist was announced during our mid-semester exams, so we had
        only the weekend to prepare before the interviews. During this short
        time, I focused on revising my projects in depth, anticipating the types
        of questions that could be asked about their implementation and logic. I
        also revised DSA, OOP and DBMS concepts and went through previous years’
        CSI Internship Diaries to understand the interview pattern and
        frequently asked questions.
      </p>

      <p>
        <strong>
          How many Interview Rounds were there for the company, can you
          elaborate about each round in brief? Also mention, how many students
          were shortlisted after each Interview Round?
        </strong>
        <br />
        There were <strong>3 interview rounds</strong>:
      </p>

      <ol>
        <li>
          Technical Round 1 (Online, \~1 hour, \~18 shortlisted):
          <br />
          Started with a discussion of my DBMS SQL project (a movie tracker).
          <br />
          Questions included:
          <br />
          Writing relations and drawing the ER diagram of a BookMyShow-style
          system.
          <br />
          Choosing an appropriate search algorithm for database queries, writing
          its code, and analyzing its time complexity.
          <br />
          Writing an SQL query to delete entries based on a condition.
          <br />
          Other basic DBMS questions.
          <br />
          Discussion then shifted to OOP concepts, including multithreading,
          race conditions, and synchronization.
          <br />
          Finally, I was asked to write code for a palindrome check, handling
          both even and odd length strings. Also I was asked why I wanted to
          join Wells Fargo.{" "}
        </li>
      </ol>

      <p>2. Senior Managerial Round 2 (FTF, \~20-30mins):</p>

      <p>
        This round began with the question, “What do you know about Wells
        Fargo?”.The discussion then moved to OOP concepts:
        <br />
        I was asked to design a class for the room we were in, detailing its
        components and the types of functions it could have.
        <br />
        I explained the four OOP principles applied to this class and drew the
        class diagram.
        <br />
        Discussed the advantages of OOP over procedural programming and SOLID
        principles.
        <br />
        The conversation also covered DBMS concepts, including vertical and
        horizontal scaling.No one was eliminated in this round, as HR wanted to
        speak with all candidates.
      </p>

      <p>3. HR Round (FTF, 5–10 minutes):</p>

      <p>
        This round focused on personal and behavioral questions.
        <br />
        I was asked to introduce myself, explain what I know about Wells Fargo,
        and why I wanted to join the company.
        <br />
        They also asked a few questions related to my family background.
      </p>

      <p>
        In the end, a total of 10 students were selected for the internship.
      </p>

      <p>
        <strong>
          What Topics or Skills did the interviewers focus on during the
          interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or
          Behavioral questions)
        </strong>
        <br />
        The interviews mainly focused on DBMS and OOP concepts. A large portion
        of the discussion was about my projects, including how they were
        implemented, the ideas behind them, and the teamwork involved.
        Interviewers were also interested in how I applied technical knowledge
        to real-world problems and how I structured and organized my code.
        <br />
        Also one should know basic design patterns, UML diagrams especially
        Class diagrams.{" "}
      </p>

      <p>
        <strong>
          What are some good resources that you used in your Internship Prep?
        </strong>
        <br />
        <strong>DSA:</strong> A to Z Striver sheet, Coder Army playlist
        <br />
        <strong>OS &amp; DBMS:</strong> Love Babbar’s tutorials
        <br />
        <strong>OOP:</strong> GeeksforGeeks (GFG).
        <br />
        <strong>Revision:</strong> GFG for last-minute revision, my handwritten
        notes and YouTube videos on Most Asked Questions.
      </p>

      <p>
        <strong>Some tips to crack Coding Questions?</strong>
        <br />
        Make sure you have cleared the basics first.
        <br />
        Practice on LeetCode daily to improve speed and problem-solving skills.
        <br />
        Understand the question thoroughly before coding.
        <br />
        Start with a brute-force solution and then optimize it.
        <br />
        It’s important to pass at least a few test cases, even if you don’t
        solve the entire problem.
      </p>

      <p>
        <strong>
          How many questions were asked about Projects, Clubs, and
          Extracurricular activities in your resume
        </strong>
        ?<br />
        My technical interview was mostly focused on my projects, where I was
        asked in detail about the implementation, ideas, and teamwork involved.
        If you have mentioned clubs or extracurricular activities in your
        resume, you may also be asked about your role and contributions in those
        activities.
      </p>

      <p>
        <strong>
          Is there something specific that you would want to tell people who are
          preparing for the same company
        </strong>
        ?<br />
        Focus on DBMS, OOP, and your projects, as these are discussed in detail
        during interviews. Be ready to explain your projects thoroughly,
        including your approach, implementation. Also, research the company well
        so you can confidently answer questions like “Why Wells Fargo?”.
        Practicing coding daily and revising core concepts will give you a
        strong advantage.
      </p>

      <p>
        <strong>Any Final Tips for Juniors?</strong>
        <br />
        Start preparing early and be consistent; even small daily practice adds
        up.
        <br />
        Focus on strong fundamentals in DSA, OOP, and DBMS, as these are often
        tested.
        <br />
        Practice coding regularly on platforms like LeetCode .<br />
        Be ready to discuss your projects in depth.
        <br />
        Revise previous CSI Internship Diaries to understand interview patterns.
        <br />
        Finally, stay confident and calm during the interviews.
        <br />
      </p>

      <p>
        <strong>Contact Info </strong>
        <br />
        <strong>Email :</strong> <a href="mailto:sarthikakashmire61@gmail.com">sarthikakashmire61@gmail.com</a>
        <br />
        <strong>LinkedIn :</strong>{" "}
        <a href="https://www.linkedin.com/in/sarthika-kashmire-b156a331a/">
          Sarthika Kashmire
        </a>
      </p>

      <hr />
    </div>
  );
};

export default sarthika_kashmire;
